// IM-CTX-REQ-028: cadastro de conta (somente quando PUBLIC_SIGNUP_ENABLED=true no servidor).
import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { companyAdapter } from '../data/context';
import { BrandLogo } from '../components/BrandLogo';
import { friendlyError } from '../lib/errors';

export function Signup() {
  const { replaceMe } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (busy) return;
    const f = new FormData(e.currentTarget);
    setBusy(true);
    setError(null);
    try {
      replaceMe(await companyAdapter.signup({ name: String(f.get('name')), email: String(f.get('email')), password: String(f.get('password')) }));
      navigate('/empresa/nova', { replace: true });
    } catch (err) {
      setError(friendlyError(err, 'Não foi possível criar a conta agora. Tente novamente. Se o problema continuar, entre em contato com o suporte.'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="onboarding">
      <BrandLogo variant="public" />
      <form className="card source-form" onSubmit={submit} aria-labelledby="signup-title">
        <div className="card-head"><div><h1 id="signup-title" className="h2">Criar conta</h1><p className="card-sub">Depois você informa a empresa e o site.</p></div></div>
        {error && <div className="form-error" role="alert">{error}</div>}
        <div className="form-grid">
          <div className="field"><label htmlFor="su-name">Nome</label><input id="su-name" name="name" required minLength={2} maxLength={120} autoComplete="name" /></div>
          <div className="field"><label htmlFor="su-email">E-mail</label><input id="su-email" name="email" type="email" required autoComplete="email" /></div>
          <div className="field"><label htmlFor="su-password">Senha (mín. 10 caracteres)</label><input id="su-password" name="password" type="password" required minLength={10} autoComplete="new-password" /></div>
        </div>
        <div className="form-actions"><Link to="/login" className="secondary-link">Já tenho conta</Link><button className="cta" disabled={busy}>{busy ? 'Criando…' : 'Criar conta'}</button></div>
      </form>
    </main>
  );
}
